var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.01074V19.92L10.6191 9.35337L0 1.01074Z",
    fill: "#124729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.594 12.4911C15.4501 12.6043 15.2767 12.6611 15.1034 12.6611C14.93 12.6611 14.7567 12.6048 14.6128 12.4911L11.8775 10.3423L1.12598 21.0403H29.0808L18.3293 10.3423L15.594 12.4911Z",
    fill: "#124729"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2072 19.92V1.01074L19.5881 9.35337L30.2072 19.92Z",
    fill: "#124729"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.921 0H1.28589L15.1034 10.856L28.921 0Z",
    fill: "#124729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.eb3680fa85454d752af73868f219817d.svg";
export { ForwardRef as ReactComponent };